import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { authFetch } from '../api';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export default function Portal() {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUser = async () => {
      const res = await authFetch('get-session');
      if (res?.data?.user) {
        setUser(res.data.user);
      }
    };
    fetchUser();
  }, []);

  const handleLogout = async () => {
    await authFetch('sign-out', { method: 'POST' });
    localStorage.removeItem('user_id');
    window.location.href = '/';
  };

  return (
    <div className="min-h-screen bg-[#FAFAFA] font-sans text-stone-900">
      <header className="bg-white border-b border-stone-200 py-4 px-6 md:px-12 flex items-center justify-between">
        <Link to="/" className="flex items-center">
            <img 
              src="https://media-manager-c.questera.ai/greta-media/5c1e3a15fc68e7fca62dc4ec64936fd2c3f13f974599de31727b7a91865820cd8939af7242306cdc50be50497057948e/images/aW1hZ2UvcG5n/d6937394eb4d6a56959e8c727708d311.png" 
              alt="Starkare Logo" 
              className="h-8 w-auto object-contain"
            />
        </Link>
        <div className="flex items-center gap-6">
            <span className="text-sm font-light text-stone-600 hidden sm:inline-block">Inloggad som {user?.name || user?.email}</span>
            <button 
              onClick={handleLogout}
              className="flex items-center gap-2 text-sm text-stone-600 hover:text-stone-900 transition-colors"
            >
                <SafeIcon icon={FiIcons.FiLogOut} />
                Logga ut
            </button>
        </div>
      </header>

      <main className="container mx-auto px-6 md:px-12 py-12">
        <div className="mb-12">
            <h1 className="text-4xl font-serif mb-4">Min Portal</h1>
            <p className="text-stone-500 font-light">Välkommen till din personliga hälsoportal. Här kommer du snart att kunna se dina program och logga dina framsteg.</p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-white p-8 border border-stone-200 shadow-sm">
                <SafeIcon icon={FiIcons.FiActivity} className="text-3xl text-stone-400 mb-4" />
                <h3 className="text-xl font-serif mb-2">Träningsprogram</h3>
                <p className="text-sm text-stone-500 font-light mb-4">Se dina aktuella träningsupplägg och instruktioner.</p>
                <button className="text-xs uppercase tracking-widest text-stone-900 font-medium hover:text-stone-500 transition-colors" disabled>Kommer snart →</button>
            </div>
            
            <div className="bg-white p-8 border border-stone-200 shadow-sm">
                <SafeIcon icon={FiIcons.FiCoffee} className="text-3xl text-stone-400 mb-4" />
                <h3 className="text-xl font-serif mb-2">Kostplan</h3>
                <p className="text-sm text-stone-500 font-light mb-4">Hitta dina individanpassade kostråd och recept.</p>
                <button className="text-xs uppercase tracking-widest text-stone-900 font-medium hover:text-stone-500 transition-colors" disabled>Kommer snart →</button>
            </div>

            <div className="bg-white p-8 border border-stone-200 shadow-sm">
                <SafeIcon icon={FiIcons.FiMessageSquare} className="text-3xl text-stone-400 mb-4" />
                <h3 className="text-xl font-serif mb-2">Meddelanden</h3>
                <p className="text-sm text-stone-500 font-light mb-4">Kommunicera direkt med din coach.</p>
                <button className="text-xs uppercase tracking-widest text-stone-900 font-medium hover:text-stone-500 transition-colors" disabled>Kommer snart →</button>
            </div>
        </div>
      </main>
    </div>
  );
}